import { useState, useEffect } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import {
  BeneficiariesCard,
  InfoBeneficiary,
  Editables,
  ButtonContainer,
  AddressBeneficiary
} from './cardBeneficiaries.styles';
import states from 'src/constants/states';
import { useSelector } from 'react-redux';
import countries from 'src/constants/countries';
import ModalWarning from 'src/components/shared/modals/warning/warning';
import { getInvestorBeneficiaries } from 'src/graphql/customized_queries';
import { updateBeneficiary } from 'src/graphql/customized_mutations';

export default function CardBeneficiaries(props) {
  const [editable, setEditable] = useState(false);
  const [warningModal, setWarningModal] = useState(false);
  const [updatedBeneficiaryData, setUpdatedBeneficiaryData] = useState(
    props.beneficiaryData || defaultBeneficiaryData
  );
  const defaultBeneficiaryData = {
    firstName: '',
    lastNameP: '',
    lastNameM: '',
    relationship: '',
    percentage: '',
    street: '',
    numInt: '',
    numExt: '',
    country: '',
    state: '',
    district: '',
    postalCode: ''
  };
  const user = useSelector((state) => state.user.currentUser);

  const handleInputChange = (event) => {
    setUpdatedBeneficiaryData({
      ...updatedBeneficiaryData,
      [event.target.name]: event.target.value
    });
  };
  useEffect(() => {
    setUpdatedBeneficiaryData(props.beneficiaryData);
  }, [props.beneficiaryData]);

  const sendDataToServer = async () => {
    try {
      const result = await API.graphql(
        graphqlOperation(updateBeneficiary, {
          input: updatedBeneficiaryData
        })
      );
      setEditable(false);
      props.onRefreshData();
    } catch (error) {
      console.error('Error updating beneficiary:', error);
    }
  };

  const handleEdit = () => {
    setEditable(true);
    setUpdatedBeneficiaryData(props.beneficiaryData);
  };
  const handleDelete = () => {
    setWarningModal(true);
  };

  const cancelEdit = () => {
    setEditable(false);
  };
  if (!updatedBeneficiaryData) {
    return null;
  }
  return (
    <BeneficiariesCard editData={handleEdit}>
      <ModalWarning
        showModal={warningModal}
        onClose={() => setWarningModal(false)}
        beneficiaryId={props.beneficiaryData.id}
        onDelete={props.onDelete}
      />
      {editable ? (
        <ButtonContainer>
          <button onClick={sendDataToServer}>Aceptar</button>
          <button onClick={cancelEdit}>Cancelar</button>
        </ButtonContainer>
      ) : (
        <ButtonContainer>
          <button onClick={handleDelete}>Eliminar</button>
          <button onClick={() => setEditable(true)}>Editar</button>
        </ButtonContainer>
      )}
      <h2>Datos del beneficiario:</h2>
      <InfoBeneficiary>
        {editable ? (
          <div>
            <h3>Nombre(s):</h3>
            <input
              value={updatedBeneficiaryData.firstName}
              name="firstName"
              onChange={handleInputChange}
            />
          </div>
        ) : (
          <div>
            <h3>Nombre(s):</h3>
            <p>{props.beneficiaryData.firstName ? props.beneficiaryData.firstName : '-'}</p>
          </div>
        )}
        {editable ? (
          <div>
            <h3>Apellido paterno:</h3>
            <input
              value={updatedBeneficiaryData.lastNameP}
              name="lastNameP"
              onChange={handleInputChange}
            />
          </div>
        ) : (
          <div>
            <h3>Apellido paterno:</h3>
            <p>{props.beneficiaryData.lastNameP}</p>
          </div>
        )}
        {editable ? (
          <div>
            <h3>Apellido materno:</h3>
            <input
              value={updatedBeneficiaryData.lastNameM}
              name="lastNameM"
              onChange={handleInputChange}
            />
          </div>
        ) : (
          <div>
            <h3>Apellido materno:</h3>
            <p>{props.beneficiaryData.lastNameM}</p>
          </div>
        )}
        {editable ? (
          <div>
            <h3>Relación o parentesco:</h3>
            <select
              value={updatedBeneficiaryData.relationship}
              name="relationship"
              onChange={handleInputChange}
            >
              <option value={undefined}>Seleccionar...</option>
              <option value="padre">Padre</option>
              <option value="madre">Madre</option>
              <option value="hijo-a">Hijo (a)</option>
              <option value="esposo-a">Esposo (a)</option>
              <option value="hermano-a">Hermano (a)</option>
            </select>
          </div>
        ) : (
          <div>
            <h3>Relación o parentesco:</h3>
            <p>{props.beneficiaryData.relationship}</p>
          </div>
        )}
        {editable ? (
          <div>
            <h3>Porcentaje:</h3>
            <select
              value={updatedBeneficiaryData.percentage}
              name="percentage"
              onChange={handleInputChange}
            >
              <option value={undefined}>Seleccionar...</option>
              <option value="10">10%</option>
              <option value="20">20%</option>
              <option value="25">25%</option>
              <option value="30">30%</option>
              <option value="40">40%</option>
              <option value="50">50%</option>
              <option value="60">60%</option>
              <option value="70">70%</option>
              <option value="80">80%</option>
              <option value="90">90%</option>
              <option value="100">100%</option>
            </select>
          </div>
        ) : (
          <div>
            <h3>Porcentaje:</h3>
            <p>{props.beneficiaryData.percentage * 100} %</p>
          </div>
        )}
        {/* {editable ? (
          <div>
            <h3>Tipo de domicilio:</h3>
            <select>
              <option value="none">Seleccionar:</option>
              <option value="OWN">Propio</option>
              <option value="RENT">Rentado</option>
              <option value="FAMILIAR">Familiar</option>
            </select>
          </div>
        ) : (
          <div>
            <h3>Tipo de domicilio:</h3>
            <p>Rentado</p>
          </div>
        )} */}
      </InfoBeneficiary>
      <h2>Domicilio actual:</h2>
      <AddressBeneficiary>
        {editable ? (
          <div>
            <h3>Calle:</h3>
            <input
              name="street"
              value={updatedBeneficiaryData.street}
              onChange={handleInputChange}
            />
          </div>
        ) : (
          <div>
            <h3>Calle:</h3>
            <p>{props.beneficiaryData.street}</p>
          </div>
        )}
        {editable ? (
          <div>
            <h3>Número externo:</h3>
            <input
              name="numExt"
              value={updatedBeneficiaryData.numExt}
              onChange={handleInputChange}
            />
          </div>
        ) : (
          <div>
            <h3>Número externo:</h3>
            <p>{props.beneficiaryData.numExt}</p>
          </div>
        )}
        {editable ? (
          <div>
            <h3>Número interno:</h3>
            <input
              name="numInt"
              value={updatedBeneficiaryData.numInt}
              onChange={handleInputChange}
            />
          </div>
        ) : (
          <div>
            <h3>Número interno:</h3>
            <p>{props.beneficiaryData.numInt}</p>
          </div>
        )}
        {editable ? (
          <div>
            <h3>País: </h3>
            <select
              value={updatedBeneficiaryData.country}
              name="country"
              onChange={handleInputChange}
            >
              {countries.map((country) => (
                <option key={country} value={country}>
                  {country}
                </option>
              ))}
            </select>
          </div>
        ) : (
          <div>
            <h3>País: </h3>
            <p>{props.beneficiaryData.country}</p>
          </div>
        )}
        {editable ? (
          <div>
            <h3>Estado:</h3>
            <select value={updatedBeneficiaryData.state} name="state" onChange={handleInputChange}>
              {states.map((state) => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select>
          </div>
        ) : (
          <div>
            <h3>Estado:</h3>
            <p>{props.beneficiaryData.state}</p>
          </div>
        )}
        {editable ? (
          <div>
            <h3>Municipio o Alcaldía:</h3>
            <input
              name="district"
              value={updatedBeneficiaryData.district}
              onChange={handleInputChange}
            />
          </div>
        ) : (
          <div>
            <h3>Municipio o Alcaldía:</h3>
            <p>{props.beneficiaryData.district}</p>
          </div>
        )}
        {editable ? (
          <div>
            <h3>Código postal:</h3>
            <input
              name="postalCode"
              value={updatedBeneficiaryData.postalCode}
              onChange={handleInputChange}
            />
          </div>
        ) : (
          <div>
            <h3>Código postal:</h3>
            <p>{props.beneficiaryData.postalCode}</p>
          </div>
        )}
      </AddressBeneficiary>
    </BeneficiariesCard>
  );
}
